import { z } from 'zod'

export const exportSchema = z.object({
  dateRange: z.enum(['7', '28', '90', 'custom']),
  startDate: z.string().optional().default(''),
  endDate: z.string().optional().default('')
}).superRefine((data, ctx) => {
  if (data.dateRange !== 'custom') return

  if (!data.startDate) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Start date is required',
      path: ['startDate']
    })
  }
  if (!data.endDate) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'End date is required',
      path: ['endDate']
    })
  }
  if (data.startDate && data.endDate && data.endDate < data.startDate) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'End date must be after start date',
      path: ['endDate']
    })
  }
})
